import { Value } from "../value.js";
/**
 * @public
 */
export class Tuple extends Value {
    static of(...values) {
        return new Tuple(values);
    }
    _values;
    constructor(values) {
        super("tuple", Value.hasCalculation(...values));
        this._values = values;
    }
    get values() {
        return this._values;
    }
    resolve(resolver) {
        return new Tuple(this._values.map((value) => value.resolve(resolver)));
    }
    partiallyResolve(resolver) {
        return new Tuple(this._values.map((value) => value.resolve(resolver)));
    }
    equals(value) {
        return (Tuple.isTuple(value) &&
            value._values.length === this._values.length &&
            value._values.every((value, i) => value.equals(this._values[i])));
    }
    hash(hash) {
        for (const value of this._values) {
            value.hash(hash);
        }
        hash.writeUint32(this._values.length);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            values: this._values.map((value) => value.toJSON()),
        };
    }
    toString() {
        return `${this._values.join(" ")}`.trim();
    }
}
/**
 * @public
 */
(function (Tuple) {
    function isTuple(value) {
        return value instanceof Tuple;
    }
    Tuple.isTuple = isTuple;
})(Tuple || (Tuple = {}));
//# sourceMappingURL=tuple.js.map